/* Modulo Clinical Results, ring draw + count-up, lazy via IntersectionObserver.
   Sections don't load the theme-extension core, so we roll our own observer
   (per the hero-proof lesson) rather than relying on window.moduloLazyInit. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var SELECTOR = '[data-modulo-clr][data-clr-animate]';
  var CIRC = 2 * Math.PI * 44; // matches the r=44 circle in the Liquid/CSS
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateRing(ring) {
    if (ring.dataset.clrDone === '1') return;
    ring.dataset.clrDone = '1';

    var pct = parseInt(ring.getAttribute('data-pct'), 10);
    if (isNaN(pct)) pct = 0;
    var prog = ring.querySelector('.modulo-clr__ring-prog');
    var num = ring.querySelector('.modulo-clr__ring-num');
    var target = CIRC * (1 - pct / 100);

    // Restore the CSS transition (init() cleared it) and let it run to target.
    if (prog) {
      prog.style.transition = '';
      requestAnimationFrame(function () { prog.style.strokeDashoffset = String(target); });
    }
    if (!num) return;

    var start = null;
    var duration = 1400;
    var root = ring.closest('[data-modulo-clr]');
    if (root) {
      var spd = parseInt(root.getAttribute('data-clr-speed'), 10);
      if (!isNaN(spd)) duration = spd;
    }
    function tick(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3); // cubic-bezier(.22,1,.36,1) approx
      num.textContent = Math.round(eased * pct) + '%';
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init(root) {
    if (root.dataset.clrInit === '1') return;
    root.dataset.clrInit = '1';

    var rings = root.querySelectorAll('[data-clr-ring]');
    if (!rings.length) return;

    // Reduced motion: leave the server-rendered filled rings + real numbers as-is.
    if (REDUCED) return;

    // Empty only the rings that are OFF-screen at init, so they draw when scrolled
    // into view. Rings already on-screen keep their server-painted filled stroke
    // (no filled->empty->fill flash); we just zero their number so the count-up
    // still reads naturally from 0.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < rings.length; i++) {
      var prog = rings[i].querySelector('.modulo-clr__ring-prog');
      var num = rings[i].querySelector('.modulo-clr__ring-num');
      var rect = rings[i].getBoundingClientRect();
      var inView = rect.bottom > 0 && rect.top < vh;
      if (!inView && prog) {
        prog.style.transition = 'none';
        prog.style.strokeDashoffset = String(CIRC);
      }
      if (num) num.textContent = '0%';
    }
    // Force a reflow so any empty state is committed before the transition is restored.
    /* eslint-disable no-unused-expressions */
    root.offsetWidth;
    /* eslint-enable no-unused-expressions */

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < rings.length; j++) animateRing(rings[j]);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateRing(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    for (var k = 0; k < rings.length; k++) io.observe(rings[k]);
  }

  function boot() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init the section that was just (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (e.target.matches && e.target.matches(SELECTOR)) root = e.target;
    if (root) { root.dataset.clrInit = ''; init(root); }
  });
})();
